<template>
  <div id="ModalAllowLogin">
    <transition name="fade">
      <div class="fixed inset-0 z-50" v-if="isAllowLoginModalVisible">
        <div
          class="absolute inset-0 bg-black bg-opacity-75"
          @click="onAllowLoginToggle"
        ></div>
        <div
          class="flex flex-col items-center justify-center w-screen h-screen"
        >
          <div class="relative animodal-inner">
            <div
              class="rounded-lg bg-white border border-stone-500 overflow-hidden"
            >
              <div v-if="loginStatusMessage" class="text-center px-10 lg:px-32">
                <div class="">
                  <!-- <font-awesome-icon
                    v-if="exitUploadMessage !== null"
                    class="text-green-600 z-20 h-28 py-2"
                    icon="fa-check-circle"
                  /> -->
                </div>
                <div class="py-2">
                  <div class="p-4 text-black">
                    <div class="text-lg font-bold text-center">
                      Login Status Changed Successfully
                    </div>
                    <div class="mt-4 text-sm text-center font-bold">
                      {{ loginStatusMessage }}
                    </div>
                  </div>
                </div>

                <div class="text-center">
                  <button
                    class="m-3 bg-green-600 text-white px-5 py-2 rounded-md"
                    @click="onAllowLoginToggle"
                  >
                    Close
                  </button>
                </div>
              </div>
              <div
                v-if="loginStatusErrorMessage"
                class="text-center px-10 lg:px-32"
              >
                <div class="">
                  <!-- <font-awesome-icon
                    v-if="exitUploadMessage !== null"
                    class="text-red-600 z-20 h-28 py-2"
                    icon="fa-exclamation-circle"
                  /> -->
                </div>
                <div class="py-2">
                  <div class="p-4 text-black">
                    <div class="text-lg font-bold text-center">
                      Login status request failed
                    </div>
                    <div class="mt-4 text-sm text-center font-bold">
                      {{ loginStatusErrorMessage }}
                    </div>
                  </div>
                </div>

                <div class="text-center">
                  <button
                    class="m-3 bg-red-600 text-white px-5 py-2 rounded-md"
                    @click="onAllowLoginToggle"
                  >
                    Close
                  </button>
                </div>
              </div>
              <div
                class="p-6"
                v-if="!loginStatusMessage && !loginStatusErrorMessage"
              >
                <div>
                  Are you sure you want to change
                  <span class="text-[#FF8200]">{{
                    getContactDeleteDetails?.name
                  }}</span>
                  status to
                  <span
                    v-if="getContactDeleteDetails?.allow_login === '1'"
                    class="font-bold text-red-600"
                    >False</span
                  >
                  <span
                    v-if="getContactDeleteDetails.allow_login === '0'"
                    class="font-bold text-red-600"
                    >True</span
                  >
                </div>
                <div class="text-center">
                  <button
                    class="m-3 text-white px-5 py-2 rounded-md"
                    :disabled="loginStatusLoading"
                    :class="loginStatusLoading ? 'bg-gray-600' : 'bg-red-600'"
                    @click.prevent="onAllowLoginToggle"
                  >
                    Close
                  </button>
                  <button
                    @click="toggleLoginStatus(getContactDeleteDetails)"
                    :disabled="loginStatusLoading"
                    :class="loginStatusLoading ? 'bg-gray-600' : 'bg-green-600'"
                    class="m-3 text-white px-5 py-2 rounded-md"
                  >
                    <span v-if="loginStatusLoading">Submitting</span>
                    <span v-else>Submit</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    isAllowLoginModalVisible: Boolean,
    onAllowLoginToggle: Function,
    loginStatusMessage: String,
    // exitUploadMessage: String,
    loginStatusErrorMessage: String,
    getContactDeleteDetails: String,
    loginStatusLoading: Boolean,
    toggleLoginStatus: Function,
  },
};
</script>

<style></style>
